import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  AppBar,
  Toolbar,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Container,
  CssBaseline,
  Snackbar,
  SnackbarContent,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Select,
  MenuItem,
  Avatar,
  Grid,
  CardContent,
  useMediaQuery,
  CardActionArea,
  InputAdornment,
  CardHeader,
  Card,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Error,
  Close,
  Email,
  Help,
  WebAsset,
  Timeline,
  Equalizer,
  DirectionsBus,
  Block,
  AccountCircle,
  MoreVert
} from "@material-ui/icons";

import { useHistory } from "react-router-dom";
import MaskedInput from "react-text-mask";
import { useSnackbar } from "notistack";

import icon from "../../assets/img/logo_primary.svg";
import CardShowcase from "../../assets/svg/topup.svg";
import Mtn from "../../assets/svg/mtn.svg";
import Visa from "../../assets/img/visa.png";
import MasterCard from "../../assets/img/master.png";
import Airtel from "../../assets/img/airtel.png";
import Ekash from "../../assets/img/e_kash.jpeg";

import Footer from "./footer.jsx";

import { withLocalize, Translate } from "react-localize-redux";
import { FinanceService } from "../../utils/web_config_2";
import axiosRetry from "axios-retry";
import { red } from '@material-ui/core/colors';
import { set } from "date-fns";
const axios = require("axios");

axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: 15,
  },
  btn: {
    textTransform: "capitalize",
  },
  card: {
    borderRadius: 15,
    // background:"#F7C62E"
  },
  avatar: {
    backgroundColor: "#687365",
  }
}));

function MaskedCard(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "6",
        "2",
        "9",
        "2",
        "-",
        "9",
        "5",
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}

      placeholderChar={"*"}
      showMask={true}
      keepCharPositions={true}
    />
  );
}


function TopUp(props) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));




  useEffect(() => {

  }, []);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  // payment mode

  const [paymentMode, setPaymentMode] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [waitting, setWaitting] = useState();


  const [names, setNames] = useState({ value: "", error: "" });
  const [cardNumber, setCardNumber] = useState({ value: "", error: "" });
  const [email, setEmail] = useState({ value: "", error: "" });
  const [phoneNumber, setPhoneNumber] = useState({ value: "", error: "" });
  const [amount, setAmount] = useState({ value: 0, error: "" });


  const [paymentLoad, setPaymentLoad] = useState(false);


  const [response, setResponse] = useState({});

  const request_paymemnt = () => {
    if (names.value == "") {
      setNames({ value: "", error: "Invalid name" });
    } else if (cardNumber.value == "") {
      setCardNumber({ value: "", error: "Invalid card number" });
    } else if (phoneNumber.value == "") {
      setPhoneNumber({ value: "", error: "Invalid phone number" });
    } else if (amount.value <= 0) {
      setAmount({ value: 0, error: "Invalid amount" });
    } else {
      setPaymentLoad(true);

      // var testSix="5129-52";
      // var prodSix="6292-95";
      var cardN = cardNumber.value;

      const paymentInstance = axios.create(new FinanceService().setHeadersMicroservice(new FinanceService().TOP_UP_TOKEN));

      const data = {
        "payment_mode": paymentMode,
        "service_name": "CARD_TOPUP",
        "consumer_reference": cardN,
        "consumer_msisdn": phoneNumber.value,
        "consumer_email": email.value,
        "amount": parseInt(amount.value)
      };

      paymentInstance.post(new FinanceService().TOP_UP_CARD, data)
        .then(res => {

          if (paymentMode == "CARD") {

            enqueueSnackbar("Payment requested successful,Please confirm", {
              variant: "success",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
          } else if (paymentMode == "MTN_MOBILE_MONEY" || paymentMode == "AIRTEL_MOBILE_MONEY") {

            enqueueSnackbar("Please confirm transaction with your phone ", {
              variant: "success",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
          }


          var data = res.data.data;
          setResponse(data);
          if (data.url != "" && data.url != " ") {
            console.log("going to checkout link");
            console.log(data.url);
            // window.location.href = data.url; 
            window.open(data.url, "_blank")
          }

          setPaymentLoad(false);
          setPaymentMode("");
          setShowDialog(false);
          /// reset data
          setNames({ value: "", error: "" });
          setCardNumber({ value: "", error: "" });
          setEmail({ value: "", error: "" });
          setPhoneNumber({ value: "", error: "" });
          setAmount({ value: 0, error: "" });


        })
        .catch(err => {
          setPaymentLoad(false);
          if (err?.response) {
            enqueueSnackbar(err?.response?.data?.message, {
              variant: "error",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
          } else {
            enqueueSnackbar(err?.message, {
              variant: "error",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
          }
        });
    }
  }


  // validate fsp account
  const [fspAccount, setFspAccount] = useState({ value: "", error: "" })
  const [fspAccountInfo, setFspAccountInfo] = useState({ validated: false })
  const [validateLoading, setValidateLoading] = useState(false)
  const [showRndpsDialog,setShowRndpsDialog] = useState(false);
  const validate_fsp_account = () => {
    console.log("clicked!!!")
    setValidateLoading(true)
    const validateInstance = axios.create(new FinanceService().setHeadersMicroservice(new FinanceService().TOP_UP_TOKEN));
    const data = {
      "fsp_account": fspAccount.value
    };
    validateInstance.post(new FinanceService().VALIDATE_FSP_ACCOUNT, data)
      .then(res => {
        setValidateLoading(false)
        var data = res.data.data;
        console.log(data)
        setFspAccountInfo({
          ...fspAccountInfo,
          data,
          validated: true
        })

      })
      .catch(err => {
        setValidateLoading(false)
        if (err?.response) {
          enqueueSnackbar(err?.response?.data?.message, {
            variant: "error",
            action: (k) => (
              <IconButton
                onClick={() => {
                  closeSnackbar(k);
                }}
                size="small"
              >
                <Close fontSize="small" />
              </IconButton>
            ),
          });
        } else {
          enqueueSnackbar(err?.message, {
            variant: "error",
            action: (k) => (
              <IconButton
                onClick={() => {
                  closeSnackbar(k);
                }}
                size="small"
              >
                <Close fontSize="small" />
              </IconButton>
            ),
          });
        }
      });

  }


  // request rndps credit transfer 
  const rndps_request = () => {
    if (cardNumber.value == "") {
      setCardNumber({ value: "", error: "Invalid card number" });
    } else if (amount.value <= 0) {
      setAmount({ value: 0, error: "Invalid amount" });
    } else {

      setPaymentLoad(true);
      const data = {
        "channel_type": "WEB",
        "card_number": cardNumber.value,
        "credit_fsp_code": fspAccountInfo?.data?.fsp_code,
        "credit_fsp_account": fspAccountInfo?.data?.fsp_account_number,
        "credit_fsp_account_name": fspAccountInfo?.data?.fsp_account_name,
        "amount": amount.value,
        "ext_ref_no": `${Math.floor(Math.random() * 1000000000).toString()}`,
        "description": "RNDPS TRANSFER"

      };
      const transferInstance = axios.create(new FinanceService().setHeadersMicroservice(new FinanceService().TOP_UP_TOKEN));
      transferInstance.post(new FinanceService().RNDPS_CREDIT_TRANSFER, data)
        .then(res => {
          setPaymentLoad(false);
          var data = res.data.data;
          console.log(data)
          // setReferenceNumber(data.ext_ref_no)
          history.push(`otpVerification/${data.ext_ref_no}`)
        })
        .catch(err => {
          setPaymentLoad(false);
          if (err?.response) {
            enqueueSnackbar(err?.response?.data?.message, {
              variant: "error",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
          } else {
            enqueueSnackbar(err?.message, {
              variant: "error",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
          }
        });
    }
  }

  const [checked, setChecked] = useState(false);



  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* Dialogs---------------------- */}


      <Dialog
        open={showDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        onClose={() => {
          setPaymentMode("");
          setShowDialog(false);
        }}
      >
        <DialogTitle id="alert-dialog-title">
          Card Top-up
        </DialogTitle>

        <DialogContent>
          <Box >
            <Box mt={1}>
              <FormControl fullWidth variant="outlined" error={cardNumber.error != ""}>
                <InputLabel htmlFor="formatted-code" size="small">
                  Card Number
                </InputLabel>
                <Input
                  endAdornment={
                    <InputAdornment position="end">
                      <img
                        src={icon}
                        style={{ height: 30 }}
                        className={classes.icon}
                        alt="Icon"
                        onClick={() => history.push("/")}
                      />
                    </InputAdornment>
                  }
                  onChange={(e) => {
                    setCardNumber({ value: e.target.value, error: "" });

                  }}
                  value={cardNumber.value}
                  color="primary"
                  varient="outlined"
                  inputComponent={MaskedCard}
                  placeholder="Enter your Card Number here"
                />
                <FormHelperText id="code">{cardNumber.error}</FormHelperText>
              </FormControl>
            </Box>

            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={names.value}
                    placeholder={translate(
                      "card_top_up.form.name"
                    )}
                    label={
                      <Translate id="card_top_up.form.name" />
                    }
                    fullWidth
                    InputProps={{
                      readOnly: false,
                    }}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setNames({ value: "", error: "Invalid names" });
                      } else {
                        setNames({ value: e.target.value, error: "" });
                      }

                    }}
                    helperText={names.error}
                    error={names.error !== ""}
                  />
                )}
              </Translate>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6} sm={6}>
                <Box mt={2}  >
                  <Translate>
                    {({ translate }) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        color="primary"
                        type="text"
                        value={phoneNumber.value}
                        placeholder={translate(
                          "card_top_up.form.phone"
                        )}
                        label={
                          <Translate id="card_top_up.form.phone" />
                        }
                        fullWidth
                        InputProps={{
                          readOnly: false,
                        }}
                        onChange={(e) => {
                          if (e.target.value == "") {
                            setPhoneNumber({ value: "", error: "Invalid phone number" });
                          } else {
                            setPhoneNumber({ value: e.target.value, error: "" });
                          }

                        }}
                        helperText={phoneNumber.error}
                        error={phoneNumber.error !== ""}
                      />
                    )}
                  </Translate>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={6} sm={6}>
                <Box mt={2}  >
                  <Translate>
                    {({ translate }) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        color="primary"
                        type="text"
                        value={email.value}
                        placeholder={translate(
                          "card_top_up.form.email"
                        )}
                        label={
                          <Translate id="card_top_up.form.email" />
                        }
                        fullWidth
                        InputProps={{
                          readOnly: false,
                        }}
                        onChange={(e) => {
                          if (e.target.value == "") {
                            setEmail({ value: "", error: "Invalid email" });
                          } else {
                            setEmail({ value: e.target.value, error: "" });
                          }

                        }}
                        helperText={email.error}
                        error={email.error !== ""}
                      />
                    )}
                  </Translate>
                </Box>
              </Grid>
            </Grid>


            <Box mt={2}  >
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="number"
                    value={amount.value}
                    placeholder={translate(
                      "card_top_up.form.amount"
                    )}
                    label={
                      <Translate id="card_top_up.form.amount" />
                    }
                    fullWidth
                    InputProps={{
                      readOnly: false,
                    }}
                    onChange={(e) => {
                      if (amount <= 0) {
                        setAmount({ value: 0, error: "Invalid amount" });
                      } else {
                        setAmount({ value: e.target.value, error: "" });
                      }

                    }}
                    helperText={amount.error}
                    error={amount.error !== ""}
                  />
                )}
              </Translate>
            </Box>



          </Box>

          <Box><Typography><b>NB</b>: Transaction fees <b>{paymentMode == "CARD" ? Number(amount.value > 0 && (amount.value * 2.8) / 100).toFixed(2) + "RWF" : Number(amount.value > 0 && (amount.value * 2.8) / 100).toFixed(2) + "RWF"}</b> will be applied on every payment request!</Typography></Box>

        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setPaymentMode("");
              setShowDialog(false);
            }}
            variant="outlined"
            color="primary"
          >
            <Translate id="users.forms.buttons.cancel" />
          </Button>
          <Button
            disabled={paymentLoad}
            variant="contained"
            color="primary"
            onClick={() => {
              request_paymemnt();
            }}
            disableElevation
          >
            {paymentLoad ? <CircularProgress size={23} color="secondary" /> : "Request"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ------------------------- */}


      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar>
          <Box mr={2}>
            <img
              src={icon}
              style={{ height: 45 }}
              className={classes.icon}
              alt="Icon"
              onClick={() => history.push("/")}
            />
          </Box>
          <Typography variant="h5" className={classes.title}>
            Card Top-up
          </Typography>
          <IconButton>
            <Help />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md">
        <Box pt={10} >
          <Box p={2} display="flex" flexDirection="column">
            <img
              src={CardShowcase}
              style={{ height: 200 }}
            />
            <Typography color="textSecondary" align="center">
              Select Payment mode to be used in topup payment
            </Typography>
            <Box
              mb={1}
              pt={4}
              display="flex"

              alignItems="center"
              justifyContent="center"
            >
              <Grid container spacing={2}>
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                  >
                    <CardActionArea
                      className={classes.action}
                      onClick={() => {

                        setPaymentMode("MTN_MOBILE_MONEY");
                        setShowDialog(true);

                        // enqueueSnackbar("Currently Disabled", {
                        //     variant:"info",
                        //     action: (k) => (
                        //       <IconButton
                        //         onClick={() => {
                        //           closeSnackbar(k);
                        //         }}
                        //         size="small"
                        //       >
                        //         <Close fontSize="small" />
                        //       </IconButton>
                        //     ),
                        //   });
                      }}
                    >
                      <Paper className={classes.card} elevation={0}>
                        <Box
                          height="150px"
                          width={1}
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                          border={0}
                          borderRadius="borderRadius"
                          borderColor="grey.300"
                        >

                          <img alt="icon" src={Mtn} height={100} />

                        </Box>
                      </Paper>
                    </CardActionArea>
                    <Box mt={1}>
                      <Typography color="inherit">{"MOMO"}</Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={2} md={2} lg={2}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                  >
                    <CardActionArea
                      className={classes.action}
                      onClick={() => {

                        setPaymentMode("AIRTEL_MOBILE_MONEY");
                        setShowDialog(true);
                      }}
                    >
                      <Paper className={classes.card} elevation={0}>
                        <Box
                          height="150px"
                          width={1}
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                          border={0}
                          borderRadius="borderRadius"
                          borderColor="grey.300"
                        >

                          <img alt="icon" src={Airtel} height={100} />

                        </Box>
                      </Paper>
                    </CardActionArea>
                    <Box mt={1}>
                      <Typography color="inherit">{"AIRTEL"}</Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={2} md={2} lg={2}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                  >
                    <CardActionArea
                      className={classes.action}
                      onClick={() => {
                        setPaymentMode("CARD");
                        setShowDialog(true);
                      }}
                    >
                      <Paper className={classes.card} elevation={0}>
                        <Box
                          height="150px"
                          width={1}
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                          border={0}
                          borderRadius="borderRadius"
                          borderColor="grey.300"
                        >

                          <img alt="icon" src={Visa} height={30} />

                        </Box>
                      </Paper>
                    </CardActionArea>
                    <Box mt={1}>
                      <Typography color="inherit">{"VISA"}</Typography>
                    </Box>
                  </Box>
                </Grid>



                <Grid item xs={6} sm={2} md={2} lg={2}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                  >
                    <CardActionArea
                      className={classes.action}
                      onClick={() => {
                        setPaymentMode("CARD");
                        setShowDialog(true);
                      }}
                    >
                      <Paper className={classes.card} elevation={0}>
                        <Box
                          height="150px"
                          width={1}
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                          border={0}
                          borderRadius="borderRadius"
                          borderColor="grey.300"
                        >

                          <img alt="icon" src={MasterCard} height={60} />

                        </Box>
                      </Paper>
                    </CardActionArea>
                    <Box mt={1}>
                      <Typography color="inherit">{"MasterCard"}</Typography>
                    </Box>
                  </Box>
                </Grid>


                <Grid item xs={6} sm={2} md={2} lg={2}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                  >
                    <CardActionArea
                      className={classes.action}
                      onClick={() => {
                        setShowRndpsDialog(true);
                      }}
                    >
                      <Paper className={classes.card} elevation={0}>
                        <Box
                          height="150px"
                          width={1}
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                          border={0}
                          borderRadius="borderRadius"
                          borderColor="grey.300"
                        >
                          <img alt="icon" src={Ekash} height={70} />
                        </Box>
                      </Paper>
                    </CardActionArea>
                    <Box mt={1}>
                      <Typography color="inherit">{"E-Kash"}</Typography>
                    </Box>
                  </Box>
                </Grid>

              </Grid>

            </Box>

          </Box>



        </Box>

      </Container>
      <Container maxWidth="lg">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={12}
          alignContent="center"
          width={1}
        >
          <div className={classes.ln2} />
          <Typography variant="h5" gutterBottom>
            <b>Top-Up Card</b>
          </Typography>
          <div className={classes.ln} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={10}
          alignContent="center"
          width={1}
        >
          <Box width={!fullScreen ? 1 / 2 : 1}>
            <Typography align="center">
              Top-up card is a way of booking your SafariBus card
              online and get it at one of our branches without waiting in
              queues.
            </Typography>
          </Box>
        </Box>

        <Grid container justify="center" alignContent="center">
          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Timeline fontSize="large" />
                </Avatar>
              </Box>

              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Equalizer fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <DirectionsBus fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </Container>
      <Footer />

      {/* RNDPS Dialogs---------------------- */}


      <Dialog
        open={showRndpsDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        onClose={() => {
          setPaymentMode("");
          setShowRndpsDialog(false);
        }}
      >
        <DialogTitle id="alert-dialog-title">
        Top-up
        </DialogTitle>

        <DialogContent>
          <Box >
            {fspAccountInfo.validated ? <Box>
              <Card >
                <CardHeader
                  avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>
                      {fspAccountInfo?.data?.fsp_account_name?.substring(0, 1)}
                    </Avatar>
                  }
                  action={
                    <IconButton aria-label="settings">
                      <MoreVert />
                    </IconButton>
                  }
                  title={fspAccountInfo?.data?.fsp_account_name}
                  subheader={fspAccountInfo?.data?.fsp_account_number}
                />
              </Card>
            </Box> : <></>}

            {fspAccountInfo.validated ?
              <Box>

                <Box mt={1}>
                  <FormControl fullWidth variant="outlined" error={cardNumber.error != ""}>
                    <InputLabel htmlFor="formatted-code" size="small">
                      {/* Card Number */}
                    </InputLabel>
                    <Input
                      endAdornment={
                        <InputAdornment position="end">
                          <img
                            src={icon}
                            style={{ height: 30 }}
                            className={classes.icon}
                            alt="Icon"
                            onClick={() => history.push("/")}
                          />
                        </InputAdornment>
                      }
                      onChange={(e) => {
                        setCardNumber({ value: e.target.value, error: "" });

                      }}
                      value={cardNumber.value}
                      color="primary"
                      varient="outlined"
                      inputComponent={MaskedCard}
                      placeholder="Enter your Card Number here"
                    />
                    <FormHelperText id="code">{cardNumber.error}</FormHelperText>
                  </FormControl>
                </Box>

                <Box mt={2}  >
                  <Translate>
                    {({ translate }) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        color="primary"
                        type="number"
                        value={amount.value}
                        placeholder={translate(
                          "card_top_up.form.amount"
                        )}
                        label={
                          <Translate id="card_top_up.form.amount" />
                        }
                        fullWidth
                        InputProps={{
                          readOnly: false,
                        }}
                        onChange={(e) => {
                          if (amount <= 0) {
                            setAmount({ value: 0, error: "Invalid amount" });
                          } else {
                            setAmount({ value: e.target.value, error: "" });
                          }

                        }}
                        helperText={amount.error}
                        error={amount.error !== ""}
                      />
                    )}
                  </Translate>
                </Box>

              </Box> : <></>
            }



            {!fspAccountInfo.validated ? <> <Grid container spacing={2}>
              <Grid item xs={12} md={10} lg={10} sm={10}>
                <Box mt={2}>
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={fspAccount.value}
                    placeholder={"FSP Account"}
                    label={"FSP Account"}
                    fullWidth
                    InputProps={{
                      readOnly: false,
                    }}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setFspAccount({ value: "", error: "Invalid FSP Account" });
                      } else {
                        setFspAccount({ value: e.target.value, error: "" });
                      }

                    }}
                    helperText={fspAccount.error}
                    error={fspAccount.error !== ""}
                  />
                </Box>

              </Grid>
              <Grid item xs={12} md={2} lg={2} sm={2}>
                <Box mt={2}  >
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={validateLoading}
                    onClick={() => {
                      validate_fsp_account();
                    }}
                    disableElevation
                  >
                    {validateLoading ? <CircularProgress size={23} color="secondary" /> : "Validate"}
                  </Button>

                </Box>
              </Grid>
            </Grid></> : <></>}
            {fspAccountInfo.validated?<>
        
                <Box>
                <FormControlLabel control={<Checkbox checked={checked} name="checkedC" onChange={(v) => { setChecked(v.target.checked)}} />} label={<Typography style={{ fontSize: '14px' }}>I have read and constent to Safaribus platform processing my information accordance to <a href=''>privacy</a> and <a href=''>terms & conditions</a></Typography>} />
                </Box>
            </>:<></>}
          </Box>
        </DialogContent>

        <DialogActions>
          {fspAccountInfo.validated ? <>
            <Button
              onClick={() => {
                setPaymentMode("");
                setShowRndpsDialog(false);
              }}
              variant="outlined"
              color="primary"
            >
              <Translate id="users.forms.buttons.cancel" />
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!checked}
              onClick={() => {
                if (!paymentLoad) {
                  rndps_request();
                }
              }}
              disableElevation
            >
              {paymentLoad ? <CircularProgress size={23} color="secondary" /> : "Request"}
            </Button>
          </> : <></>}
          

        </DialogActions>
      </Dialog>

      {/* RNDPS Dialogs ------------------------- */}

    </div>
  );
}

export default withLocalize(TopUp);
